import { render, staticRenderFns } from "./PhaseSection.vue?vue&type=template&id=2e4a0f88"
import script from "./PhaseSection.vue?vue&type=script&lang=js"
export * from "./PhaseSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports